import { render, staticRenderFns } from "./TestGuideImage.vue?vue&type=template&id=5b9f1478&scoped=true&"
import script from "./TestGuideImage.vue?vue&type=script&lang=js&"
export * from "./TestGuideImage.vue?vue&type=script&lang=js&"
import style0 from "./TestGuideImage.vue?vue&type=style&index=0&id=5b9f1478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9f1478",
  null
  
)

export default component.exports